import { render, staticRenderFns } from "./ObservationBehavior.vue?vue&type=template&id=880c8922&scoped=true"
import script from "./ObservationBehavior.vue?vue&type=script&lang=js"
export * from "./ObservationBehavior.vue?vue&type=script&lang=js"
import style0 from "./ObservationBehavior.vue?vue&type=style&index=0&id=880c8922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880c8922",
  null
  
)

export default component.exports